import React from 'react';

import _ from '@ihme/common/locale';
import styled from '@ihme/common/theme/styled';

import PageHeader from '../../components/PageHeader';
import ChartHighlight from '../../components/ChartHighlight';
import TrendsChartSection from './TrendsChartSection';

const PageContainer = styled.div(({ theme }) => ({
    paddingBottom: 50,
}));

class TrendsScene extends React.Component {
    render() {
        return (
            <PageContainer>
                <PageHeader>{_('trends_scene_title')}</PageHeader>
                <ChartHighlight>{_('trends_scene_description')}</ChartHighlight>
                <TrendsChartSection />
            </PageContainer>
        );
    }
}

export default TrendsScene;
